import { runInAction } from 'mobx';
import { AxiosResponse } from 'axios';

import { notUndefined } from 'ui/base/types';

import { getResponseBytes, http } from 'services/base/http';

import {
  createInvoiceObjects,
  IAccountsDomain,
  InvoiceMap,
  invoiceSorter,
} from './types';

import { InvoiceListResponse } from './protos/invoice_pb';

export class InvoicesService {
  static async fetchAll(domain: IAccountsDomain, save = true): Promise<InvoiceMap> {
    const httpResp = await http.get('/billing/invoices/');
    const remoteInvoices = parseInvoicesResponse(httpResp);
    remoteInvoices.sort(invoiceSorter);
    return runInAction(() => {
      if (save) domain.invoices = remoteInvoices;
      return remoteInvoices;
    });
  }
}

function parseInvoicesResponse(httpResp: AxiosResponse): InvoiceMap {
  const rawBytes = getResponseBytes(httpResp);
  const rootProto = InvoiceListResponse.deserializeBinary(rawBytes);
  const invoicesObjects = createInvoiceObjects(rootProto.getInvoicesList());
  return new InvoiceMap(invoicesObjects.filter(notUndefined).map((p) => [p.id, p]));
}
